<template>
  <div
    v-if="isShowPage"
    class="messages"
  >
    <navBar
      :title="lang.manageMessages"
      :show-type="'text'"
    />
    <van-tabs
      v-model="active"
      @change="activeList"
    >
      <van-tab :title="this.myQuestion.title+'('+quCount+')'">
        <van-list
          v-model="myQuestion.loading"
          :finished="myQuestion.finished"
          :finished-text="lang.noMore"
          @load="myQuestionOnLoad"
        >
          <van-cell
            v-for="item in myQuestion.list"
            :key="item.messageID"
            class="bh-message"
          >
            <div
              v-if="item.property"
              class="centa-li"
            >
              <message-list
                :item="item"
                :show-col="item.property&&colSale[item.property.propertyID]!==undefined?true:false"
              />
              <div
                v-show="item.property&&colSale[item.property.propertyID]"
                class="msg-remark"
              >
                {{ lang.remark }}{{ colSale[item.property.propertyID] }}
              </div>
              <div class="my-messages">
                <div class="flexb">
                  <div class="flex-1">
                    <p>
                      <label>{{ lang.yourMessage }}:</label>
                      <span>{{ item.leaveMessage }}</span>
                    </p>
                    <p>
                      <label>{{ lang.ownerReply }}:</label>
                      <span>{{ item.replyMessage | replyNull }}</span>
                    </p>
                  </div>
                  <button
                    class="flex-r"
                    @click="messageManage(item)"
                  >
                    {{ lang.manage }}
                  </button>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </van-tab>
      <van-tab :title="myReplies.title+'('+reCount+')'">
        <van-list
          v-model="myReplies.loading"
          :finished="myReplies.finished"
          :finished-text="lang.noMore"
          @load="myRepliesOnload"
        >
          <van-cell
            v-for="item in myReplies.list"
            :key="item.messageID"
            class="bh-message"
          >
            <div class="centa-li">
              <message-list
                :item="item"
                :show-col="item.property&&colSale[item.property.propertyID]!==undefined?true:false"
              />
              <div
                v-show="item.property&&colSale[item.property.propertyID]"
                class="msg-remark"
              >
                {{ lang.remark }}{{ colSale[item.property.propertyID] }}
              </div>

              <div class="my-messages">
                <div class="flexb">
                  <div class="flex-1">
                    <p>
                      <label>{{ lang.questionMessage }}:</label>
                      <span>{{ item.leaveMessage }}</span>
                    </p>
                    <p>
                      <label>{{ lang.myReply }}:</label>
                      <span>{{ item.replyMessage | replyNull }}</span>
                    </p>
                  </div>
                  <button
                    class="flex-r"
                    :disabled="manage"
                    @click="messageManage(item)"
                  >
                    {{ lang.manage }}
                  </button>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </van-tab>
    </van-tabs>
    <van-actionsheet
      v-model="messagePopup"
      :actions="actions"
      :cancel-text="lang.cancel"
      @select="onSelect"
      @cancel="revert"
    />
  </div>
</template>

<script>
// import {
//   Tab,
//   Tabs,
//   List,
//   Cell,
//   Popup,
//   Button,
//   Toast,
//   Dialog,
//   Actionsheet
// } from "vant";
// import "vant/lib/button/style";
import pub from '../../common/public';
import lang from "./../../common/language/messages";
import tools from "./../../common/js/tools";
import navBar from "../components/navBar.vue";
import messageList from "../components/message-list.vue";
export default {
  metaInfo: { title: lang.manageMessages },
  name: "Messages",
  components: {
    // [Tab.name]: Tab,
    // [Tabs.name]: Tabs,
    // [List.name]: List,
    // [Cell.name]: Cell,
    // [Popup.name]: Popup,
    // [Button.name]: Button,
    // [Toast.name]: Toast,
    // [Dialog.name]: Dialog,
    // [Actionsheet.name]: Actionsheet,
    navBar,
    messageList
  },
  filters:{
    picFilter(url) {
      if (!url) {
        return '/house-bg.png'
      }
      if (url.indexOf('/house-bg.png') > -1) {
        return '/house-bg.png'
      }
      return url + '?x-oss-process=style/360x270_c'
    },
    replyNull: function(val){
      if(val === null || val === ''){
        val = '--'
        return val
      }
        return val
      
    },
    /** 遍历出 房源小分类 */
    subCategory(val) {
      const arr = Object.keys(val)
      const valArr = arr
        .map(function(i) {
          return val[i]
        })
        .slice(0, 2)
      let valStr = ''
      valArr.forEach(item => {
        valStr += ' ' + item
      })
      return valStr
    },

  },
  data() {
    return {
      isShowPage: false,
      isPc: false,
      tools,
      manage:false,
      actions:[],
      curLang:'',
      msgUrl:'',
      listItem: {},
      active: '',
      lang: lang,
      messagePopup: false,
      quCount:0,
      reCount:0,
      myReplies: {
        //我的回復 active =1
        title: lang.myReplies,
        list: [],
        loading: false,
        Finished: false,
        listCount: 0,
        listQuery: {
          sourceType: "property", //來源類型
          // sourceID: "", //來源id
          isShowSourceInfo: true, //是否显示留言房源信息
          searchType: "userRelatedLeaveMessage",
          // isUserLeaveMessage: false, //登錄用戶留言
          // isUserRelatedLeaveMessage: true, //登錄用戶相關聯李艷
          pageIndex: 1,
          pageCount: 15
        }
      },
      myQuestion: {
        //我的提問 active =0
        list: [],
        title: lang.myQuestion,
        loading: false,
        Finished: false,
        listCount: 0,
        listQuery: {
          sourceType: "property", //來源類型
          // sourceID: "", //來源id
          isShowSourceInfo: true, //是否显示留言房源信息
          searchType: "userLeaveMessage",
          // isUserLeaveMessage: true, //登錄用戶留言
          // isUserRelatedLeaveMessage: false, //登錄用戶相關聯李艷
          pageIndex: 1,
          pageCount: 15
        }
      },
      colRent:{},
      colSale:{},
    };
  },
  inject: ["reload"],
  created(){
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    this.active=sessionStorage.getItem('messageTab')?sessionStorage.getItem('messageTab'):0;
    if (this.isPc) {
      if (this.active == 1) {
        if (pub.getLang() === 'zh-cn') {
          location.href = `${pub.config.pcPassport}zh-cn/tomemessage/`;
        } else if (pub.getLang() === 'en-us') {
          location.href = `${pub.config.pcPassport}en-us/tomemessage/`;
        } else {
          location.href = `${pub.config.pcPassport}tomemessage/`;
        }
      } else {
        if (pub.getLang() === 'zh-cn') {
          location.href = `${pub.config.pcPassport}zh-cn/mymessage/`;
        } else if (pub.getLang() === 'en-us') {
          location.href = `${pub.config.pcPassport}en-us/mymessage/`;
        } else {
          location.href = `${pub.config.pcPassport}mymessage/`;
        }
      }

    } else {
      this.isShowPage = true;
    }
    this.loadCollectAll("sale");
    this.loadCollectAll("rent");
  },
  methods: {
    /** 获取全部的收藏数据 */
    loadCollectAll (type) {
      this.axios
        .post(this.pub.getApi().SearchCollection, {
          sourceType: type,
          pageCount: 100,
          pageIndex: 1,
          isShowSourceInfo: true
        })
        .then(res => {
          if (res.data.code == 0) {
            res.data.result.data.forEach(item => {
              // if(type=="sale")
              if(item.property){this.$set(this.colSale,item.property.propertyID,item.remark)}
              // else this.$set(this.colRent,item.property.propertyID,item.remark)
              // this.colSale[item.property.propertyID]=;
              // else if(type=="rent"&&item.remark)
              // this.colRent[item.property.propertyID]=item.remark;
            });
            // console.log(this.colSale)

          }
        });
    },
      activeList(){
          sessionStorage.setItem('messageTab',this.active);

      },
      rentLabel(val) {
      if (val) {
        if (val[3] && val[4]) {
          return `${this.lang.shortRent}${this.lang.sublet}`
        } else if (val[3]) {
          return this.lang.shortRent
        } else if (val[4]) {
          return this.lang.sublet
        }
      }
    },
    onSelect(item, index) {
      if (index === 0) {
        this.messageChange(this.listItem);
      } else if (index === 1) {
        this.messageDel(this.listItem.messageID);
      }
    },
    async messageList(messageQuery,active) {
      try {
        let list = [];
        let count = [];
        await this.axios
          .post(this.pub.getApi().SearchLeaveMessage, messageQuery)
          .then(res => {
            list = res.data.result.data;
            active === 0?this.quCount = res.data.result.count:this.reCount = res.data.result.count;
          });
          this.curLang = this.pub.getLang(this.$route.path) || 'zh-hk';
          this.msgUrl = "/my/term";
        //我的提問
        if (active === 0) {
          this.myQuestion.listCount = Math.ceil(
            this.quCount / this.myQuestion.listQuery.pageCount
          );
          this.myQuestion.title = `${lang.myQuestion}`;
          this.myQuestion.list = this.myQuestion.list.concat(list);
          this.myQuestion.loading = false;
          //最後一頁
          if (this.myQuestion.listQuery.pageIndex > this.myQuestion.listCount) {
            this.myQuestion.loading = false;
            this.myQuestion.finished = true;
          }
        } else {
          //我的回復
          this.myReplies.listCount = Math.ceil(
            this.reCount / this.myReplies.listQuery.pageCount
          );
          this.myReplies.title = `${lang.myReplies}`;
          this.myReplies.list = this.myReplies.list.concat(list);
          this.myReplies.loading = false;
          //最後一頁
          if (this.myReplies.listQuery.pageIndex > this.myReplies.listCount) {
            this.myReplies.loading = false;
            this.myReplies.finished = true;
          }
        }
      } catch (error) {
        // console.log(error);
      }
    },
    //刪除留言
    messageDel(messageID) {
      let messageId = messageID;
        this.$dialog.confirm({
          title: this.lang.alertM[0],
          cancelButtonText: this.lang.alertM[1],
          confirmButtonText: this.lang.alertM[2]
        })
        .then(() => {
          this.axios
            .get(this.pub.getApi().DeleteLeaveMessage, {
              params: {
                messageId: messageId
              }
            })
            .then(() => {
              //暫時刷新接口出來後 做單條刪除
              if (this.active === 0) {
                this.myQuestion.list = this.myQuestion.list.filter(
                  item => item.messageID !== messageId
                );
              } else {
                this.myReplies.list = this.myReplies.list.filter(
                  item => item.messageID !== messageId
                );
              }
              this.messagePopup = false;
              this.active === 0?this.quCount--:this.reCount--;
              Toast.success(this.lang.successfullyDeleted);
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //取消彈出層
    revert() {
      this.messagePopup = false;
    },
    //管理點擊彈出層(放盤人)
    messageManage(item) {
      this.listItem = item
      let newDate = Date.parse(new Date())/1000

      //paymentStatus是0未付款  isAdminOffLine 管理員下架 expireTime 放盤過期日期
      // if(this.listItem.property.paymentStatus === 0 && this.listItem.isAdminOffLine===true && item.property.expireTime --newDate)
      this.messagePopup = true;
      if(this.active === 1){
        //我的回复如果业主回复那就不允许继续回复
      if(item&&(item.replyMessage === null || item.replyMessage === '')){
        this.actions = [
          // {
          //   subname: this.lang.selectAction
          // },
          {
            name: this.lang.messageReply
          },
          {
            name: this.lang.messageDelete
          }
        ]
      }else{
        this.actions = [
          // {
          //   subname: this.lang.selectAction
          // },
          {
              name: this.lang.messageChange
          },
          {
            name: this.lang.messageDelete
          }
        ]
      }
      }else{
        //我的提问 如果有回复那就不能删除
          this.actions = [
            // {
            //   subname: this.lang.selectAction
            // },
            {
              name: this.lang.messageChange
            },
            {
              name: this.lang.messageDelete
            }
          ]
      }
    },
    //管理點擊彈出層(咨詢人)

    messageChange(listItem) {
       let curLang=this.pub.getLang(this.$route.path) || '';
      curLang= curLang=="zh-hk"?"":curLang+"/";
      //更改留言
      if (this.active === 0) {
         window.location = `${this.pub.config.wapUrl+curLang}message/change?messageID=${listItem.messageID}&&propertyID=${listItem.property.propertyID}`;
      } else {
        //回復留言
         window.location = `${this.pub.config.wapUrl+curLang}message/reply?messageID=${listItem.messageID}&&propertyID=${listItem.property.propertyID}`;
      }
    },
    //我的回復
    myRepliesOnload() {
      //默認第一次加載
      this.myReplies.loading = true;
      if (
        this.myReplies.listCount === 0 &&
        this.myReplies.listQuery.pageIndex === 1
      ) {
        this.messageList(this.myReplies.listQuery,1);
         this.messageList(this.myQuestion.listQuery,0);
      } else {
        //滾動更新
        this.myReplies.listQuery.pageIndex =
          this.myReplies.listQuery.pageIndex + 1;
        this.messageList(this.myReplies.listQuery,1);
      }
    },
    //我的提問下拉
    myQuestionOnLoad() {
      //默認第一次加載
      this.myQuestion.loading = true;
      if (
        this.myQuestion.listCount === 0 &&
        this.myQuestion.listQuery.pageIndex === 1
      ) {
        this.messageList(this.myQuestion.listQuery,0);
        this.messageList(this.myReplies.listQuery,1);
      } else {
        //滾動更新
        this.myQuestion.listQuery.pageIndex =
          this.myQuestion.listQuery.pageIndex + 1;
        this.messageList(this.myQuestion.listQuery,0);
      }
    },
    // 跳转详情页
    detailUrl (rentalType, id) {
      let type = '';
      if (rentalType == 1) {
        type = 'buy';
      } else if (rentalType == 2) {
        type = 'rent';
      }
      if (document.URL.indexOf('en-us') > -1) {
        location.href = `/en-us/${type}-property-${id}.html`;
      } else if (document.URL.indexOf('zh-cn') > -1) {
        location.href = `/zh-cn/${type}-property-${id}.html`;
      } else {
        location.href = `/${type}-property-${id}.html`;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.message-reply {
  display: inline-block;
  color: #0076ff;
  width: 100%;
  height: 50px;
  line-height: 48px;
}
.message-del {
  color: #ed1c24;
}
// .van-cell {
//   overflow: hidden;
//   position: relative;
//   display: block;
//   padding: 14px;
//   line-height: initial;
//   border-bottom: 1px solid #f1f1f1;
// }
.flexb {
  display: flex;
}
.prop-cover {
  width: 120px;
  position: relative;
  height: 90px;
  overflow: hidden;
  min-width: 120px;
  img {
    position: absolute;
    width: 100%;
    height:100%;
  }
}
.prop-info {
  margin-left: 10px;
  overflow: hidden;
  text-align: left;
  .prop-info-title {
    font-size: 15px;
    margin-bottom: 10px;
    line-height: 20px;
    font-weight: 400;
    color: #0c0c0c;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2px;
    max-height: 40px;
  }
  .prop-info-cat {
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 2px;
    .prop-info-cat-name {
      color: #0076ff;
    }
    .prop-info-cat-type {
      margin-left: 5px;
      color: #8b8b8b;
    }
  }
  .prop-info-size {
    font-size: 12px;
    margin-bottom: 2px;
    color: #8b8b8b;
  }
  .prop-info-price {
    line-height: 16px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .prop-info-price-left {
      color: #df3031;
      font-weight: 400;
    }
    .prop-info-price-right {
      font-size: 12px;
      margin-left: 5px;
    }
  }
}
.my-messages {
  margin-top: 6px;
  margin-right:15px;
  background-color: #f1f1f1;
  padding: 8px;
  color: #0c0c0c;
  .flex-1 {
    overflow: hidden;
    margin-right: 4px;
    text-align: left;
    flex: 1;
  }
  .flex-r {
    color: #0076ff;
    line-height: 40px;
    text-align: right;
    border: 0;
    background-color: transparent;
  }
  .flex-r:disabled {
    color: #bdbdbd;
  }
  p:first-child {
    margin-top: 0;
  }
  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
    line-height: 20px;
    margin-top: 10px;
    // house提测注释
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    label {
      font-weight: 400;
      color: #808080;
      padding-right: 4px;
      text-align: right;
    }
  }
}
.msg-remark{
padding-right: 25px;
    color: #999;
    font-size: 10px;
    height: 16px;
    // position: relative;
    // top: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-bottom: 5px;
}
.bh-message{
  padding:10px 0px 10px 15px;
}
</style>

